module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "peugeot_logo_index.84d8de3f.png";